import React from 'react'
import {Row, Col, Typography} from 'antd'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {RowTableDetail, TableDetail} from "../../Common/View/TableViewDetail";
import typo from "../../../constants/dictionaries";
import FileDinhKemView from "../../CongTrinh/FileDinhKem/View";
import DiemXaThais from "../../CongTrinh/DiemXaThai/View";
import TSQT from "../../AttachTable/TSQT/Table";
import TTKT from "../../AttachTable/TTKT/Table";

import helper from '../../../helper/helper'

const {Text} = Typography;

const ThongTinCT_XT = ({congTrinh, hoSoXCP, diemXT, chatLuongNuocThai, thanhTraKiemTra}) => {

  const {
    tenCongTrinh,
    diaDiem,
    nguonTiepNhan,
    phuongThucXaThai,
    cheDoXaThai,
    luuLuongNuocThaiLonNhat,
    loaiHinhNuocThai,
    thuocLVS,
    thuocSong,
  } = congTrinh || {};

  const chatLuongNuocThais = chatLuongNuocThai ? JSON.parse(chatLuongNuocThai) : [];
  const ttkts = thanhTraKiemTra ? JSON.parse(thanhTraKiemTra) : [];

  return (
    <Row type="flex">
      <Col>
        <Row>
          <TableDetail>
            <RowTableDetail title={typo.cscore_license_construction}>{tenCongTrinh}</RowTableDetail>
            <RowTableDetail title={typo.cscore_diaDiem}>{diaDiem}</RowTableDetail>
            {/* <RowTableDetail title={typo.cscore_license_type_construction}>{loaiCongTrinh}</RowTableDetail> */}
            <RowTableDetail title={typo.cscore_loaiHinhNuocThai}>{loaiHinhNuocThai}</RowTableDetail>
            <RowTableDetail title={typo.cscore_nguonTiepNhan}>{nguonTiepNhan}</RowTableDetail>
            <RowTableDetail title={typo.cscore_phuongThucXaThai}>{phuongThucXaThai}</RowTableDetail>
            <RowTableDetail title={typo.cscore_cheDoXaThai}>{cheDoXaThai}</RowTableDetail>
            <RowTableDetail title={typo.cscore_luuLuongXaLonNhat}>{luuLuongNuocThaiLonNhat}</RowTableDetail>
            {/* <RowTableDetail title={typo.cscore_license_mining_location}></RowTableDetail> */}
            <RowTableDetail title={typo.cscore_song}>{thuocSong}</RowTableDetail>
            <RowTableDetail title={typo.cscore_thuocLuuVucSong}>{thuocLVS}</RowTableDetail>
          </TableDetail>
        </Row>
      </Col>
      {/* <Col span={11} offset={1}>
        <a>{helper.generateIndexForLabel(typo.cscore_diemXaThai, 4.1)} </a>
        <DiemXaThais dataSource={diemXT || []}/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_ttkt, 4.2)} </a>
        <TTKT mode="presentation" dataSource={ttkts || []}/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_chatLuongNuocThai, 4.3)} </a>
        <TSQT mode="presentation" dataSource={chatLuongNuocThais || []}/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_fileDinhkem, 4.4)} </a>
        <FileDinhKemView mode="presentation" dataSource={hoSoXCP || []}/>
      </Col> */}
    </Row>
  )
};

ThongTinCT_XT.propTypes = {
  congTrinh: PropTypes.any.isRequired,
  giayPhepCT: PropTypes.any.isRequired,
  hoSoXCP: PropTypes.any.isRequired,
  diemXT: PropTypes.array.isRequired,
};

export default connect()(ThongTinCT_XT)